import { useLayoutEffect, useRef } from 'react'

import { SEARCH_MODAL_ITEM_KIND } from '../const/modalItemKind.const'
import type { SearchModalItem } from '../interfaces/modalItem.interface'
import { formatDurationTag } from '../utils/formatDurationTag'

import { SearchRowBody } from './SearchRowBody'
import { SearchRowIconCell } from './SearchRowIconCell'

import styles from '../SearchModal.module.scss'

type SearchRowProps = {
  item: SearchModalItem
  isSelected: boolean
  query: string
  onHover: () => void
  onSelect: () => void
}

export function SearchRow({ item, isSelected, query, onHover, onSelect }: SearchRowProps) {
  const rowRef = useRef<HTMLLIElement>(null)

  useLayoutEffect(() => {
    if (!isSelected) {
      return
    }

    rowRef.current?.scrollIntoView({ block: 'nearest', inline: 'nearest' })
  }, [isSelected])

  const metaTag = formatDurationTag(item.durationMinutes)
  const teaserRaw = item.shortDescription?.trim() ?? ''
  const rowIconKind = item.kind ?? SEARCH_MODAL_ITEM_KIND.Documentation
  const itemContentClass = teaserRaw === '' ? `${styles.itemContent} ${styles.itemContentCompact}` : styles.itemContent

  const rowClass = `${styles.itemBtn}${isSelected ? ` ${styles.itemSelected}` : ''}`.trim()

  return (
    <li ref={rowRef} role="presentation">
      <button
        type="button"
        aria-current={isSelected ? 'true' : undefined}
        className={rowClass}
        onClick={onSelect}
        onMouseEnter={onHover}
      >
        <span className={itemContentClass}>
          <SearchRowIconCell rowIconKind={rowIconKind} icon={item.icon} kind={item.kind} />
          <SearchRowBody
            title={item.title}
            metaTag={metaTag}
            titleTag={item.titleTag}
            badge={item.badge}
            feedLabel={item.feedLabel}
            feedPrivate={item.feedPrivate}
            statusLabel={item.statusLabel}
            statusTone={item.statusTone}
            teaserRaw={teaserRaw}
            query={query}
          />
        </span>
      </button>
    </li>
  )
}
